import { render, staticRenderFns } from "./btUpdateInfoTem.vue?vue&type=template&id=25b62083"
import script from "./btUpdateInfoTem.vue?vue&type=script&lang=js"
export * from "./btUpdateInfoTem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports